export default __webpack_public_path__ + "static/media/cardsResponsive_es.ba242935.png";